export const AUTO_GENERATED_NAME = 'AUTO_GENERATED';
